import { Provider, RequestArguments } from '@web3-react/types'

type ProviderListener = (...args: any[]) => void

const FORWARDED_EVENTS = ['connect', 'disconnect', 'chainChanged', 'accountsChanged'] as const

export class ReownEip1193Provider implements Provider {
  private provider?: Provider
  private listeners = new Map<string | symbol, Set<ProviderListener>>()
  private forwardedListeners = new Map<string, ProviderListener>()

  setProvider(provider?: Provider) {
    if (this.provider === provider) return

    this.detachForwardedListeners()
    this.provider = provider
    this.attachForwardedListeners()
  }

  async request(args: RequestArguments): Promise<unknown> {
    if (!this.provider) {
      throw new Error('Reown wallet provider is not connected')
    }

    return this.provider.request(args)
  }

  on(eventName: string | symbol, listener: ProviderListener): this {
    const listeners = this.listeners.get(eventName) ?? new Set<ProviderListener>()
    listeners.add(listener)
    this.listeners.set(eventName, listeners)
    return this
  }

  removeListener(eventName: string | symbol, listener: ProviderListener): this {
    this.listeners.get(eventName)?.delete(listener)
    return this
  }

  emit(eventName: string | symbol, ...args: any[]) {
    this.listeners.get(eventName)?.forEach((listener) => listener(...args))
  }

  private attachForwardedListeners() {
    FORWARDED_EVENTS.forEach((eventName) => {
      const listener = (...args: any[]) => this.emit(eventName, ...args)
      this.forwardedListeners.set(eventName, listener)
      this.provider?.on(eventName, listener)
    })
  }

  private detachForwardedListeners() {
    this.forwardedListeners.forEach((listener, eventName) => {
      this.provider?.removeListener(eventName, listener)
    })
    this.forwardedListeners.clear()
  }
}

export const reownEip1193Provider = new ReownEip1193Provider()
